import { useOutletContext, useNavigate } from 'react-router-dom';
import type { ConnectStatus } from '../lib/api';
import { startHubspotConnect, startMicrosoftConnect } from '../lib/api';

export function ConnectPage() {
  const status = useOutletContext<ConnectStatus | null>();
  const nav = useNavigate();

  if (!status) return null;

  const ms = status.microsoft;
  const hs = status.hubspot;

  return (
    <div className="page connect">
      <span className="eyebrow">Step 01 · Connections</span>
      <h1>Wire both sides.</h1>
      <p className="page-lead">
        Pick the HubSpot portal you're importing into, then connect the Outlook mailbox
        you're importing from. Both sides need a green stamp before you can start a backfill.
      </p>

      <div className="cards">
        <div className={`card ${hs.length > 0 ? 'connected' : ''}`}>
          <div className="card-head">
            <span className="badge">1</span>
            <h2>HubSpot</h2>
          </div>
          {hs.length > 0 ? (
            <>
              <div className="status-ok">
                Connected to portal{hs.length > 1 ? 's' : ''}{' '}
                <span className="mono">{hs.map((c) => c.hubId).join(' · ')}</span>
              </div>
              <button className="secondary" onClick={startHubspotConnect}>
                + Add another portal
              </button>
            </>
          ) : (
            <>
              <p>Install mailmeback into the HubSpot portal you want to write engagements into.</p>
              <button className="primary" onClick={startHubspotConnect}>
                Connect HubSpot →
              </button>
            </>
          )}
        </div>

        <div className={`card ${ms.connected ? 'connected' : ''}`}>
          <div className="card-head">
            <span className="badge">2</span>
            <h2>Microsoft</h2>
          </div>
          {ms.connected ? (
            <>
              <div className="status-ok">
                Mailbox <span className="mono">{ms.primarySmtp}</span>
              </div>
              <p className="muted" style={{ fontSize: 13, margin: 0 }}>
                Read-only Mail.Read scope. We never store message content.
              </p>
            </>
          ) : (
            <>
              <p>Sign in with the Microsoft account whose Outlook mailbox you want to import.</p>
              <button
                className="primary"
                disabled={hs.length === 0}
                onClick={startMicrosoftConnect}
              >
                Connect Microsoft →
              </button>
              {hs.length === 0 && (
                <p className="muted" style={{ fontSize: 13, marginTop: 12 }}>
                  Connect HubSpot first.
                </p>
              )}
            </>
          )}
        </div>
      </div>

      {ms.connected && hs.length > 0 && (
        <div className="continue-cta">
          <button className="primary big" onClick={() => nav('/backfill')}>
            Continue to backfill →
          </button>
        </div>
      )}
    </div>
  );
}
